<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Update Profile </h5>
      <b-form @submit.prevent="updateProfile('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">First Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="firstname"
                        name="firstname"
                        type="text"
                        v-model="firstName"
                        v-validate="'required'"
                        :class="{'input': true,
                                 'is-danger': errors.has('formRegistration.firstname') }"
                        required
                        placeholder="First Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.firstname')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.firstname')"
                  class="help is-danger">{{ errors.first('formRegistration.firstname') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="emailGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Last Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="lastName"
                        name="lastname"
                        type="text"
                        v-model="lastName"
                        v-validate="'required'"
                        :class="{'input': true,
                                 'is-danger': errors.has('formRegistration.lastname') }"
                        required
                        placeholder="Last Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.lastname')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.lastname')"
                  class="help is-danger">{{ errors.first('formRegistration.lastname') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Username</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="email"
                        type="email"
                        name="email"
                        v-model="email"
                        v-validate="'required|email'"
                        :class="{'input': true,
                                 'is-danger': errors.has('formRegistration.email') }"
                        required
                        placeholder="Email Address">
            </b-form-input>
            <i v-show="errors.has('formRegistration.email')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.email')"
                  class="help is-danger">{{ errors.first('formRegistration.email') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Company Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="companyName"
                        name="companyName"
                        type="text"
                        v-model="companyName"
                        placeholder="Company Name">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Phone Number</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="phoneNumber"
                        name="phoneNumber"
                        type="text"
                        v-model="phoneNumber"
                        placeholder="Phone Number">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="8">
              <label for="input-small"><h5 class="mt-3 mb-3"> Billing Information </h5></label>
            </b-col>
          <b-col sm="4">

            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Billing Address</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea id="address"
                          type="text"
                          name="address"
                          v-model="address"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.address') }"
                          required
                          placeholder="Billing Address">
               </b-form-textarea>
              <i v-show="errors.has('formRegistration.address')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.address')"
                    class="help is-danger">{{ errors.first('formRegistration.address') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Billing Town/City</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="city"
                        name="city"
                        type="text"
                        v-model="city"
                        v-validate="'required'"
                        :class="{'input': true,
                                 'is-danger': errors.has('formRegistration.city') }"
                        required
                        placeholder="Town/City">
            </b-form-input>
            <i v-show="errors.has('formRegistration.city')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.city')"
                  class="help is-danger">{{ errors.first('formRegistration.city') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Billing Post Code</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="code"
                        name="code"
                        type="text"
                        v-model="code"
                        v-validate="'required'"
                        :class="{'input': true,
                                 'is-danger': errors.has('formRegistration.code') }"
                        required
                        placeholder="Post Code">
            </b-form-input>
            <i v-show="errors.has('formRegistration.code')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.code')"
                  class="help is-danger">{{ errors.first('formRegistration.code') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Billing Country</label>
            </b-col>
            <b-col sm="8">
              <b-form-select id="country"
                             name="country"
                             v-model="country"
                             class="mb-3"
                             :options="countries"
                             v-validate="'required'"
                             :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.country') }"
                             required> </b-form-select>
              <i v-show="errors.has('formRegistration.country')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.country')"
                    class="help is-danger">{{ errors.first('formRegistration.country') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
         <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Billing Email</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="billingEmail"
                        type="email"
                        name="billingEmail"
                        v-model="billingEmail"
                        disabled
                        placeholder="Billing Email Address">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">VAT Registration No.</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="vat"
                        name="vat"
                        type="text"
                        v-model="vat"
                        placeholder="VAT">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="8">
              <label for="input-small"><h5 class="mt-3 mb-3"> Security Settings </h5></label>
            </b-col>
          <b-col sm="4">

            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">2 Factor Authentication</label>
            </b-col>
          <b-col sm="8">
            <label class="switch">
            <input type="checkbox"
                   v-model="twoFactor"
                   @change="statusUpdate()">
            <span class="slider round"></span>
          </label>
            </b-col>
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          variant="warning">Update Profile</b-button>
      </b-form>
      <b-modal hide-footer v-model="modalShow" title="Welcome">
        Welcome to your dashboard. You have signed in for the first time. Please complete
        your profile.
    </b-modal>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';

export default {
  name: 'profile',
  components: { FacitHeader },
  data() {
    const userData = Session.getAccessToken().user;
    return {
      firstName: userData.firstname,
      lastName: userData.lastname,
      address: userData.address,
      code: userData.postcode,
      email: userData.email,
      vat: userData.vat,
      companyName: userData.companyname,
      phoneNumber: userData.phone,
      billingEmail: userData.billingEmail,
      newPassword: null,
      oldPassword: null,
      confirmPassword: null,
      country: userData.country,
      modalShow: true,
      city: userData.city,
      twoFactor: userData.twoFactor,
      countries: [
        { value: null, text: 'Select Country' },
        { value: 'Afghanistan', text: 'Afghanistan' },
        { value: 'Åland Islands', text: 'Åland Islands' },
        { value: 'Albania', text: 'Albania' },
        { value: 'Algeria', text: 'Algeria' },
        { value: 'American Samoa', text: 'American Samoa' },
        { value: 'Andorra', text: 'Andorra' },
        { value: 'Angola', text: 'Angola' },
        { value: 'Anguilla', text: 'Anguilla' },
        { value: 'Antarctica', text: 'Antarctica' },
        { value: 'Argentina', text: 'Argentina' },
        { value: 'Armenia', text: 'Armenia' },
        { value: 'Aruba', text: 'Aruba' },
        { value: 'Australia', text: 'Australia' },
        { value: 'Austria', text: 'Austria' },
        { value: 'Azerbaijan', text: 'Azerbaijan' },
        { value: 'Bahamas', text: 'Bahamas' },
        { value: 'Bahrain', text: 'Bahrain' },
        { value: 'Bangladesh', text: 'Bangladesh' },
        { value: 'Barbados', text: 'Barbados' },
        { value: 'Belarus', text: 'Belarus' },
        { value: 'Belgium', text: 'Belgium' },
        { value: 'Belize', text: 'Belize' },
        { value: 'Benin', text: 'Benin' },
        { value: 'Bermuda', text: 'Bermuda' },
        { value: 'Bhutan', text: 'Bhutan' },
        { value: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Brunei Darussalam', text: 'Brunei Darussalam' },
        { value: 'Bulgaria', text: 'Bulgaria' },
        { value: 'Burkina Faso', text: 'Burkina Faso' },
        { value: 'Burundi', text: 'Burundi' },
        { value: 'Cambodia', text: 'Cambodia' },
        { value: 'Cameroon', text: 'Cameroon' },
        { value: 'Canada', text: 'Canada' },
        { value: 'Central African Republic', text: 'Central African Republic' },
        { value: 'Chad', text: 'Chad' },
        { value: 'Chile', text: 'Chile' },
        { value: 'China', text: 'China' },
        { value: 'Colombia', text: 'Colombia' },
        { value: 'Congo', text: 'Congo' },
        { value: 'Cook Islands', text: 'Cook Islands' },
        { value: 'Costa Rica', text: 'Costa Rica' },
        { value: 'Côte d`Ivoire', text: 'Côte d`Ivoire' },
        { value: 'Croatia', text: 'Croatia' },
        { value: 'Cuba', text: 'Cuba' },
        { value: 'Cyprus', text: 'Cyprus' },
        { value: 'Czech Republic', text: 'Czech Republic' },
        { value: 'Denmark', text: 'Denmark' },
        { value: 'Dominica', text: 'Dominica' },
        { value: 'Dominican Republic', text: 'Dominican Republic' },
        { value: 'Ecuador', text: 'Ecuador' },
        { value: 'Egypt', text: 'Egypt' },
        { value: 'Eritrea', text: 'Eritrea' },
        { value: 'Estonia', text: 'Estonia' },
        { value: 'Ethiopia', text: 'Ethiopia' },
        { value: 'Fiji', text: 'Fiji' },
        { value: 'Finland', text: 'Finland' },
        { value: 'France', text: 'France' },
        { value: 'Gabon', text: 'Gabon' },
        { value: 'Gambia', text: 'Gambia' },
        { value: 'Georgia', text: 'Georgia' },
        { value: 'Germany', text: 'Germany' },
        { value: 'Ghana', text: 'Ghana' },
        { value: 'Gibraltar', text: 'Gibraltar' },
        { value: 'Greece', text: 'Greece' },
        { value: 'Greenland', text: 'Greenland' },
        { value: 'Grenada', text: 'Grenada' },
        { value: 'Guadeloupe', text: 'Guadeloupe' },
        { value: 'Guam', text: 'Guam' },
        { value: 'Guatemala', text: 'Guatemala' },
        { value: 'Guernsey', text: 'Guernsey' },
        { value: 'Guinea', text: 'Guinea' },
        { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
        { value: 'Guyana', text: 'Guyana' },
        { value: 'Haiti', text: 'Haiti' },
        { value: 'Honduras', text: 'Honduras' },
        { value: 'Hong Kong', text: 'Hong Kong' },
        { value: 'Hungary', text: 'Hungary' },
        { value: 'Iceland', text: 'Iceland' },
        { value: 'India', text: 'India' },
        { value: 'Indonesia', text: 'Indonesia' },
        { value: 'Islamic Republic of Iran', text: 'Islamic Republic of Iran' },
        { value: 'Iraq', text: 'Iraq' },
        { value: 'Ireland', text: 'Ireland' },
        { value: 'Israel', text: 'Israel' },
        { value: 'Italy', text: 'Italy' },
        { value: 'Jamaica', text: 'Jamaica' },
        { value: 'Japan', text: 'Japan' },
        { value: 'Jersey', text: 'Jersey' },
        { value: 'Jordan', text: 'Jordan' },
        { value: 'Kazakhstan', text: 'Kazakhstan' },
        { value: 'Kenya', text: 'Kenya' },
        { value: 'Kiribati', text: 'Kiribati' },
        { value: 'Democratic People`s Republic of Korea', text: 'Democratic People`s Republic of Korea' },
        { value: 'Republic of Korea', text: 'Republic of Korea' },
        { value: 'Kuwait', text: 'Kuwait' },
        { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
        { value: 'Latvia', text: 'Latvia' },
        { value: 'Lebanon', text: 'Lebanon' },
        { value: 'Lesotho', text: 'Lesotho' },
        { value: 'Liberia', text: 'Liberia' },
        { value: 'Libya', text: 'Libya' },
        { value: 'Liechtenstein', text: 'Liechtenstein' },
        { value: 'Lithuania', text: 'Lithuania' },
        { value: 'Luxembourg', text: 'Luxembourg' },
        { value: 'Macao', text: 'Macao' },
        { value: 'Madagascar', text: 'Madagascar' },
        { value: 'Malawi', text: 'Malawi' },
        { value: 'Malaysia', text: 'Malaysia' },
        { value: 'Maldives', text: 'Maldives' },
        { value: 'Mali', text: 'Mali' },
        { value: 'Malta', text: 'Malta' },
        { value: 'Marshall Islands', text: 'Marshall Islands' },
        { value: 'Martinique', text: 'Martinique' },
        { value: 'Mauritania', text: 'Mauritania' },
        { value: 'Mauritius', text: 'Mauritius' },
        { value: 'Mayotte', text: 'Mayotte' },
        { value: 'Mexico', text: 'Mexico' },
        { value: 'Micronesia', text: 'Micronesia' },
        { value: 'Moldova', text: 'Moldova' },
        { value: 'Monaco', text: 'Monaco' },
        { value: 'Mongolia', text: 'Mongolia' },
        { value: 'Montenegro', text: 'Montenegro' },
        { value: 'Montserrat', text: 'Montserrat' },
        { value: 'Morocco', text: 'Morocco' },
        { value: 'Mozambique', text: 'Mozambique' },
        { value: 'Myanmar', text: 'Myanmar' },
        { value: 'Namibia', text: 'Namibia' },
        { value: 'Nauru', text: 'Nauru' },
        { value: 'Nepal', text: 'Nepal' },
        { value: 'Netherlands', text: 'Netherlands' },
        { value: 'New Caledonia', text: 'New Caledonia' },
        { value: 'New Zealand', text: 'New Zealand' },
        { value: 'Nicaragua', text: 'Nicaragua' },
        { value: 'Niger', text: 'Niger' },
        { value: 'Nigeria', text: 'Nigeria' },
        { value: 'Niue', text: 'Niue' },
        { value: 'Norfolk Island', text: 'Norfolk Island' },
        { value: 'Northern Mariana Islands', text: 'Northern Mariana Islands' },
        { value: 'Norway', text: 'Norway' },
        { value: 'Oman', text: 'Oman' },
        { value: 'Pakistan', text: 'Pakistan' },
        { value: 'Palau', text: 'Palau' },
        { value: 'Palestine', text: 'Palestine' },
        { value: 'Panama', text: 'Panama' },
        { value: 'Papua New Guinea', text: 'Papua New Guinea' },
        { value: 'Paraguay', text: 'Paraguay' },
        { value: 'Peru', text: 'Peru' },
        { value: 'Philippines', text: 'Philippines' },
        { value: 'Pitcairn', text: 'Pitcairn' },
        { value: 'Poland', text: 'Poland' },
        { value: 'Portugal', text: 'Portugal' },
        { value: 'Puerto Rico', text: 'Puerto Rico' },
        { value: 'Qatar', text: 'Qatar' },
        { value: 'Réunion', text: 'Réunion' },
        { value: 'Romania', text: 'Romania' },
        { value: 'Russian Federation', text: 'Russian Federation' },
        { value: 'Rwanda', text: 'Rwanda' },
        { value: 'Saint Barthélemy', text: 'Saint Barthélemy' },
        { value: 'Saint Helena', text: 'Saint Helena, Ascension and Tristan da Cunha' },
        { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
        { value: 'Saint Lucia', text: 'Saint Lucia' },
        { value: 'Saint Pierre and Miquelon', text: 'Saint Pierre and Miquelon' },
        { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
        { value: 'Samoa', text: 'Samoa' },
        { value: 'San Marino', text: 'San Marino' },
        { value: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
        { value: 'Saudi Arabia', text: 'Saudi Arabia' },
        { value: 'Senegal', text: 'Senegal' },
        { value: 'Serbia', text: 'Serbia' },
        { value: 'Seychelles', text: 'Seychelles' },
        { value: 'Sierra Leone', text: 'Sierra Leone' },
        { value: 'Singapore', text: 'Singapore' },
        { value: 'Sint Maarten', text: 'Sint Maarten' },
        { value: 'Slovakia', text: 'Slovakia' },
        { value: 'Slovenia', text: 'Slovenia' },
        { value: 'Solomon Islands', text: 'Solomon Islands' },
        { value: 'Somalia', text: 'Somalia' },
        { value: 'South Africa', text: 'South Africa' },
        { value: 'South Sudan', text: 'South Sudan' },
        { value: 'Spain', text: 'Spain' },
        { value: 'Sri Lanka', text: 'Sri Lanka' },
        { value: 'Sudan', text: 'Sudan' },
        { value: 'Suriname', text: 'Suriname' },
        { value: 'Swaziland', text: 'Swaziland' },
        { value: 'Sweden', text: 'Sweden' },
        { value: 'Switzerland', text: 'Switzerland' },
        { value: 'Syrian Arab Republic', text: 'Syrian Arab Republic' },
        { value: 'Taiwan', text: 'Taiwan' },
        { value: 'Tajikistan', text: 'Tajikistan' },
        { value: 'Tanzania', text: 'Tanzania' },
        { value: 'Thailand', text: 'Thailand' },
        { value: 'Timor-Leste', text: 'Timor-Leste' },
        { value: 'Togo', text: 'Togo' },
        { value: 'Tokelau', text: 'Tokelau' },
        { value: 'Tonga', text: 'Tonga' },
        { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
        { value: 'Tunisia', text: 'Tunisia' },
        { value: 'Turkey', text: 'Turkey' },
        { value: 'Turkmenistan', text: 'Turkmenistan' },
        { value: 'Tuvalu', text: 'Tuvalu' },
        { value: 'Uganda', text: 'Uganda' },
        { value: 'Ukraine', text: 'Ukraine' },
        { value: 'United Arab Emirates', text: 'United Arab Emirates' },
        { value: 'United Kingdom', text: 'United Kingdom' },
        { value: 'United States', text: 'United States' },
        { value: 'Uruguay', text: 'Uruguay' },
        { value: 'Uzbekistan', text: 'Uzbekistan' },
        { value: 'Vanuatu', text: 'Vanuatu' },
        { value: 'Venezuela', text: 'Venezuela' },
        { value: 'Viet Nam', text: 'Viet Nam' },
        { value: 'Virgin Islands, British', text: 'Virgin Islands, British' },
        { value: 'Virgin Islands, U.S.', text: 'Virgin Islands, U.S.' },
        { value: 'Wallis and Futuna', text: 'Wallis and Futuna' },
        { value: 'Western Sahara', text: 'Western Sahara' },
        { value: 'Yemen', text: 'Yemen' },
        { value: 'Zambia', text: 'Zambia' },
        { value: 'Zimbabwe', text: 'Zimbabwe' },
      ],
    };
  },
  created() {
    if (this.address) {
      this.modalShow = false;
    }
  },
  methods: {
    async updateProfile(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const token = Session.getAccessToken();
          const userId = token.user.id;
          const isEmailChanged = token.user.email !== this.email;
          const updateUser = await API.patch(`Accounts/${userId}`, {
            email: this.email,
            firstname: this.firstName,
            lastname: this.lastName,
            address: this.address,
            postcode: this.code,
            companyname: this.companyName,
            phone: this.phoneNumber,
            vat: this.vat,
            country: this.country,
            city: this.city,
          });
          await this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Profile has been updated',
          });
          if (isEmailChanged) {
            //await API.post(`Accounts/${userId}/verify`);
            Session.removeAccessToken();
            this.$router.push('login');
          }
          this.$router.push('/');
        }
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while updating profile',
        });
      }
    },
    async changePassword(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          await API.post('Accounts/change-password', {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
          });
          this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Password has been modified',
          });
        }
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while updating password',
        });
      }
    },
    async statusUpdate() {
      const token = Session.getAccessToken();
      const userId = token.user.id;
      const twoFactorAuth = await API.patch(`Accounts/${userId}`, {
        twoFactor: this.twoFactor,
      });
      if (this.twoFactor) {
        this.$notify({
          group: 'sitewide',
          title: 'Success!',
          type: 'success',
          text: 'Two Factor Authentication is enabled',
        });
      } else {
        this.$notify({
          group: 'sitewide',
          title: 'Success!',
          type: 'success',
          text: 'Two Factor Authentication is disabled',
        });
      }
      Session.updateUser(twoFactorAuth);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/updateProfile.vue